// extracted by mini-css-extract-plugin
export default {"root":"SectionHero_root__zeQDy","second":"SectionHero_second__qCSLS","ourStory":"SectionHero_ourStory__U1FaV","ourStoryContent":"SectionHero_ourStoryContent__z1ynJ"};